function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import digitalData from 'digital-data';
import { NUCLEUS } from '../../../constants.js';
import { makeEverythingLowerCase, setAnalytics, getCategoryBreadCrumbs } from '../../../thd-analytics-utils.js';
export const getCollectionPageType = _ref => {
  let {
    type = ''
  } = _ref;
  switch (type) {
    case 'Integrated Brand Template':
      return 'integrated';
    case 'Grouped View':
      return 'patio';
    case 'List View Template':
      return 'list view';
    case 'Space':
      return 'space';
    default:
      return '';
  }
};
export function collections() {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('collections.data', _ref2 => {
    var _collectionDetail$tax, _digitalData$page, _digitalData$page2;
    let {
      output: collectionDetail
    } = _ref2;
    if (!collectionDetail) return;
    const category = getCategoryBreadCrumbs(collectionDetail === null || collectionDetail === void 0 ? void 0 : (_collectionDetail$tax = collectionDetail.taxonomy) === null || _collectionDetail$tax === void 0 ? void 0 : _collectionDetail$tax.breadCrumbs);
    const {
      type,
      name
    } = (collectionDetail === null || collectionDetail === void 0 ? void 0 : collectionDetail.metadata) || {};
    const extraPageInfo = {};
    const extraProductData = {};
    const extraContentData = {};
    if (type === 'Space') {
      const {
        metadata,
        collectionId
      } = collectionDetail || {};
      const {
        primaryCurationId
      } = metadata || {};
      extraPageInfo.catalog = 'n/a';
      extraProductData.curationID = primaryCurationId;
      extraContentData.collection = {
        collectionID: collectionId
      };
    }
    digitalData.page = {
      pageInfo: _objectSpread({
        collectionVariance: '',
        pageName: `${category === null || category === void 0 ? void 0 : category.subCategory2}>${name}`,
        pageType: `collections:${getCollectionPageType({
          type
        })}`,
        platform: NUCLEUS
      }, extraPageInfo),
      category
    };
    digitalData.page.pageInfo = makeEverythingLowerCase(digitalData === null || digitalData === void 0 ? void 0 : (_digitalData$page = digitalData.page) === null || _digitalData$page === void 0 ? void 0 : _digitalData$page.pageInfo);
    digitalData.page.category = makeEverythingLowerCase(digitalData === null || digitalData === void 0 ? void 0 : (_digitalData$page2 = digitalData.page) === null || _digitalData$page2 === void 0 ? void 0 : _digitalData$page2.category);
    const products = ((collectionDetail === null || collectionDetail === void 0 ? void 0 : collectionDetail.products) || []).map((product, i) => {
      var _product$identifiers;
      return _objectSpread({
        productInfo: {
          position: i,
          sku: product === null || product === void 0 ? void 0 : (_product$identifiers = product.identifiers) === null || _product$identifiers === void 0 ? void 0 : _product$identifiers.itemId
        }
      }, extraProductData);
    });
    digitalData.content = _objectSpread({
      product: products
    }, extraContentData);
    setAnalytics(digitalData);
  });
}
//# sourceMappingURL=collections.js.map